import React from "react";
import classNames from "classnames";
import { DoorIconProps } from "../doorOptions/DeKaap";

export const Populair3: React.FC<DoorIconProps> = ({ isActive = false }) => {
  return (
    <svg
      width="29"
      height="60"
      viewBox="0 0 29 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classNames("gg-transition gg-ease-in-out gg-duration-150", {
        "gg-fill-[#292747]": isActive,
        "gg-fill-[#9493A3]": !isActive,
      })}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26.274 2H3.001v56h23.273V2ZM1.001 0v60h27.273V0H1.001Z"
      />
      <mask id="a" fill="#fff">
        <path d="M.91 23h4v14h-4V23Z" />
      </mask>
      <path d="M.91 23h4v14h-4V23Z" />
      <path d="M4.91 36h-4v2h4v-2Z" mask="url(#a)" />
    </svg>
  );
};
